import React, { useImperativeHandle, forwardRef, useState, useCallback } from 'react';
import { Form, Drawer, Input, Button, Space, message, Spin } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { editDevices, getDeviceDetail, getProductInfo } from '@/api';
import { DevicesType } from '@/api/devices';
import MapFormItems from './components/MapFormItems';

const { useForm } = Form;
const { TextArea } = Input;

export interface EditModalProps {
  onFinish: () => void;
}

export interface EditModalRef {
  open: (record?: DevicesType) => void;
}

export const EditModal = forwardRef<EditModalRef, EditModalProps>(({ onFinish }, ref) => {
  const [form] = useForm();
  const [record, setRecord] = useState<DevicesType>();
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const handleClose = useCallback(() => {
    form.resetFields();
    setIsModalOpen(false);
  }, [form]);

  const [product, setProduct] = useState<{ id?: string; node_type?: string }>({});
  const getProductDetail = async (id: string) => {
    try {
      const res = await getProductInfo(id);
      // form.setFieldsValue(res.result);
      setProduct(res.result || {});
    } catch {
    } finally {
      setLoading(false);
    }
  };
  const [loading, setLoading] = useState<boolean>(false);
  const getDetail = async (id: string) => {
    setLoading(true);
    try {
      const res = await getDeviceDetail(id);
      form.setFieldsValue(res.result);
      res.result?.product_id && getProductDetail(res.result?.product_id);
    } catch {
    } finally {
      setLoading(false);
    }
  };

  useImperativeHandle(ref, () => {
    return {
      open(record) {
        setRecord(record);
        setIsModalOpen(true);
        if (record) {
          getDetail(record.id);
        }
      },
    };
  }, [form]);

  return (
    <Drawer
      title={'编辑设备'}
      placement="right"
      open={isModalOpen}
      width={550}
      closable={false}
      maskClosable={false}
      styles={{ header: { height: 51 } }}
      destroyOnClose
      extra={<CloseOutlined onClick={handleClose} />}
      onClose={handleClose}
      footer={
        <Space>
          <Button
            type="primary"
            loading={submitting}
            disabled={submitting}
            onClick={() => {
              form.validateFields().then((values) => {
                setSubmitting(true);

                editDevices({
                  ...values,
                  name: values?.name || '',
                  id: record?.id!,
                  description: values?.description,
                  image: values?.image,
                  lat: values?.lat ? String(values?.lat) : '',
                  lon: values?.lon ? String(values?.lon) : '',
                })
                  .then((resp) => {
                    if (resp.success) {
                      message.success('编辑成功');
                      handleClose();
                      onFinish();
                    } else {
                      message.error(resp.errorMsg);
                    }
                  })
                  .finally(() => {
                    setSubmitting(false);
                  });
              });
            }}
          >
            确定
          </Button>
          <Button onClick={handleClose}>取消</Button>
        </Space>
      }
    >
      <Spin spinning={loading}>
        <Form form={form} layout="vertical">
          <Form.Item label="设备名称" name="name" rules={[{ required: true, message: '请输入设备名称' }]}>
            <Input placeholder="请输入驱动名称"></Input>
          </Form.Item>
          <Form.Item label="设备唯一标识" name="device_sn" rules={[{ required: true, message: '请输入设备唯一标识' }]}>
            <Input placeholder="请输入设备唯一标识" allowClear></Input>
          </Form.Item>
          {/* <Form.Item label="设备状态" name="status">
            <Input placeholder="请输入容器名称" disabled></Input>
          </Form.Item>
          <Form.Item label="平台" name="platform">
            <Input placeholder="请输入协议" disabled></Input>
          </Form.Item> */}
          {/* <Form.Item label="关联驱动" name="driver_service_name">
            <Input placeholder="请输入驱动标识" disabled></Input>
          </Form.Item> */}
          {product?.node_type === '监控设备' && ''}
          {/* {product?.node_type === '监控设备' ? (
            <Form.Item label="国际设备ID" name="device_sn">
              <Input placeholder="请输入国际设备ID"></Input>
            </Form.Item>
          ) : (
            <Form.Item label="关联驱动" name="driver_service_name">
              <Input placeholder="请输入驱动标识" disabled></Input>
            </Form.Item>
          )} */}
          <MapFormItems></MapFormItems>
          <Form.Item label="描述" name="description">
            <TextArea placeholder="请输入描述" rows={4}></TextArea>
          </Form.Item>
        </Form>
      </Spin>
    </Drawer>
  );
});

export default EditModal;
